import logo from "@/src/logo.svg";
import { Button } from "@/src/components/ui/button";
import { Link } from "react-router-dom";

export function BadLink() {
  return (
    <div className="h-screen w-screen p-2 relative flex place-content-center bg-white">
      <img src={logo} className="absolute w-16 h-9 left-11 top-7"></img>
      <div className="flex flex-col items-center justify-center">
        <h1 className="text-3xl font-semibold">Invalid login link</h1>
        <span className="text-base mt-4">
          This login link is invalid or has been used already, please try again.
        </span>
        <span className="text-5xl mt-5">🔒️</span>
        <Button className="mt-5" asChild>
          <Link to="/login">Back to login</Link>
        </Button>
      </div>
    </div>
  );
}
